import { render, staticRenderFns } from "./ListUserRole.vue?vue&type=template&id=533b0943"
import script from "./ListUserRole.vue?vue&type=script&lang=js"
export * from "./ListUserRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports